var LoginPage = require('./LoginPage');
module.exports = LoginPage;